import { render, staticRenderFns } from "./Certificate.vue?vue&type=template&id=e8153c6e&scoped=true"
import script from "./Certificate.vue?vue&type=script&lang=js"
export * from "./Certificate.vue?vue&type=script&lang=js"
import style0 from "./Certificate.vue?vue&type=style&index=0&id=e8153c6e&prod&scoped=true&lang=css"
import style1 from "./Certificate.vue?vue&type=style&index=1&id=e8153c6e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8153c6e",
  null
  
)

export default component.exports